<template>
    <div class="data-pagination text-center">
        <button @click="goFirst" :disabled="is_first_page" type="button"
            class="btn btn-primary btn-wabident-round mx-1">
            <i class="fas fa-angle-double-left"></i>
        </button>
        <button @click="goPrev" :disabled="is_first_page" type="button" class="btn btn-primary btn-wabident-round mx-1">
            <i class="fas fa-angle-left"></i>
        </button>
        <label class="customer-search-pagination-locator mx-2">
            Página
            {{ page }} de {{ total }}
        </label>
        <button @click="goNext" :disabled="is_last_page" type="button" class="btn btn-primary btn-wabident-round mx-1">
            <i class="fas fa-angle-right"></i>
        </button>
        <button @click="goLast" :disabled="is_last_page" type="button" class="btn btn-primary btn-wabident-round mx-1">
            <i class="fas fa-angle-double-right"></i>
        </button>
    </div>
</template>

<script>
export default {
    props: ['page', 'total'],
    computed: {
        is_first_page() {
            return this.page == 1;
        },
        is_last_page() {
            return this.page == this.total;
        }
    },
    methods: {
        goFirst() {
            this.gotoPage(1);
        },
        goLast() {
            this.gotoPage(this.total);
        },
        goNext() {
            this.gotoPage(this.page + 1);
        },
        goPrev() {
            this.gotoPage(this.page - 1);
        },
        gotoPage(page) {
            this.$emit('gotopage', page);
        }
    }
}
</script>